import { Link } from "@tanstack/react-router";

/**
 * CTA link that opens the Banana web app in a new tab when the destination is
 * the sign-up flow. All other routes are rendered as normal in-app Links.
 */
export function CtaLink({
  to,
  className,
  children,
  ...props
}: {
  to: string;
  className?: string;
  children?: React.ReactNode;
} & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href">) {
  if (to === "/signup") {
    return (
      <a
        href="https://app.banana.cards"
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <Link to={to} className={className} {...props}>
      {children}
    </Link>
  );
}
